module.exports = "<h1>Exports</h1>\r\n\r\n<p>\r\n    Export Outcomes result data.\r\n</p>\r\n\r\n<button class=\"btn btn-primary\" (click)=\"exportResults()\">Export</button>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/export/export.html
 ** module id = 686
 ** module chunks = 0
 **/